import React, { useEffect, useState } from "react";
import {
  Dialog,DialogContent,Typography
} from "@mui/material";
import UpdateUserForm from "./UpdateUserForm";

export default function UpdateUserModal({ open, onClose, userData, onUserUpdated }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(userData);
  }, [userData]);

  const handleSuccess = () => {
    onClose();
    onUserUpdated();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        {user ? (
          <UpdateUserForm userData={user} onSuccess={handleSuccess} />
        ) : (
          <Typography>Cargando...</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
